import { FormatStateStore, FormatState } from 'common/stores/FormatStateStore';

export class MRAIDFormatStateStore extends FormatStateStore {
  constructor(protected formatConfig: any) {
    super();

    if (this.formatConfig.injectOnViewable) {
      this._state = FormatState.Loaded;
      // Keep listening to PreloadErrorEvent to catch errors like empty tag
      this.unsubscribeFromBus(['preload']);
    }
  }
}
